import React, { useEffect } from 'react';
import { Route, Redirect, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { authSelector, checkUserToken } from '../../Auth/authSlice';
import PrivateRoute from '../PrivateRoute';
import Dashboard from '../../ClerkPanel/Dashboard/index';
import FrontAllProcess from '../../ClerkPanel/Process/index';
import kivProcess from '../../ClerkPanel/Process/kiv/index';
import FrontViewAllUser from '../../ClerkPanel/ViewAllUser/index';
import FrontViewProcess from '../../ClerkPanel/ViewAllProcess/index';
import Notification from '../../ClerkPanel/Notification/index';
import AddDocument from '../../ClerkPanel/AddDocument/index';
import DocumentVerification from '../../DocumentVerification/DocumentVerification';
import DocumentVerification2 from '../../DocumentVerification/DocumentVerification2';
import DocumentSignature from '../../DocumentSignature/index';
import ability from '../../../config/ability';

import DocumentEditor from '../../DocumentEditor/DocumentEditor';

import CommonEditor from '../../CollaborationDocumentEditor/CommonEditor';

import CollaborateDocument from '../../ClerkPanel/CollaborateDocument/index';

import AddMultipleProcessDocument from '../../ClerkPanel/AddMultipleProcessDocument';

export default function ClerkRoutes() {

  const dispatch = useDispatch();
  let history = useHistory();
  const { isLoggedIn, user } = useSelector(
    authSelector
  );

  useEffect(() => {
    dispatch(checkUserToken()).then((res) => {
      if (res.message === "unauthorized") { history.push('/'); }
    }).catch((err) => {
      // console.log("err=>   ", err)
    });
  }, [])

  return (
    <>
      {user.userType == 'Clerk'
        ? <>
          <PrivateRoute path="/dashboard" component={Dashboard} />
          <PrivateRoute path="/add-document" component={AddDocument} exact />
          <PrivateRoute path="/verify-document" component={DocumentVerification} exact />
          <PrivateRoute path="/verify-document2" component={DocumentVerification2} exact />
          <PrivateRoute path="/document-editor" component={DocumentEditor} exact />
          <PrivateRoute path="/document-signin" component={DocumentSignature} exact />
          <PrivateRoute path="/use-this-document" component={AddMultipleProcessDocument} exact />
          <PrivateRoute path="/all-process" component={FrontAllProcess} exact />
          <PrivateRoute path="/kiv-process" component={kivProcess} exact />
          <PrivateRoute path="/view-all-users" component={FrontViewAllUser} exact />
          <PrivateRoute path="/view-process" component={FrontViewProcess} exact />
          <PrivateRoute path="/view-all-notification" component={Notification} exact />
          <PrivateRoute path="/new-document" component={CommonEditor} exact />
          <PrivateRoute path="/draft-document" component={CollaborateDocument} exact />
        </>
        : <Redirect to="/login" />
      }

    </>
  );
}


